export default __webpack_public_path__ + "static/Places_Placeholder_1.0@2x-9e4fe5c5d023083b504c07f01d192722.jpg";